import { Box, Container } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import 'swiper/swiper-bundle.css'

import { useUser } from '@/client/context/user'

import ExploreFooterLoggedOut from './ExploreFooterLoggedOut'

export default function ExploreFooter({
  hideLoggedIn = false,
  courseSlug = null,
  hideFaq = false,
}: {
  hideLoggedIn?: boolean
  courseSlug?: string | null
  hideFaq?: boolean
}): ReactElement | null {
  const user = useUser()

  if (hideLoggedIn && !user.isLoggedOut) {
    return null
  }
  return (
    <Box bgColor="bg.subtle">
      <Container>
        {user.isLoggedOut ? (
          <ExploreFooterLoggedOut hideFaq={hideFaq} courseSlug={courseSlug} />
        ) : null}
      </Container>
    </Box>
  )
}
